import { getString } from '../../../strings';
import SuccessMessage from '../../molecules/SuccessMessage';

const AddHourSuccess = ({ data, students, subjects, hasFree, lang }) => {
    return (
        <SuccessMessage
            title={getString('UserPanelTrainerTrackHours__form_submit__succ') + ':'}
            infos={[
                {
                    title:
                        getString('UserPanelTrainerTrackHours__form_submit_after__for_who') + ':',
                    value: (() => {
                        const student = students.find((student) => student.id === data.student);
                        return student
                            ? `${student.firstname} ${student.lastname}`
                            : 'Unknown student';
                    })(),
                },
                {
                    title:
                        getString('UserPanelTrainerTrackHours__form_submit_after__subject') + ':',
                    value: subjects.find((s) => s.id === data.subject)?.description[lang],
                },
                {
                    title: getString('UserPanelTrainerTrackHours__form_submit_after__hours') + ':',
                    value: data.hours,
                },
                ...(hasFree && data.free
                    ? [
                          {
                              title:
                                  getString('UserPanelTrainerTrackHours__form_submit_after__free') +
                                  ':',
                              value: getString('YES'),
                          },
                      ]
                    : []),
                {
                    title: getString('UserPanelTrainerTrackHours__form_submit_after__when') + ':',
                    value: data.date.split('-').reverse().join('.'),
                },
            ]}
        />
    );
};

export default AddHourSuccess;
